import { apiClient as publicApiClient, unwrap } from '@/shared/api-client/public';

export type PublicWaiverAcknowledgement = {
  text: string;
  required: boolean;
};

export type SignerCapacity = 'SELF' | 'GUARDIAN_FOR_CHILD';

export type PublicWaiverTemplate = {
  templateId: string;
  version: number;
  bodyHtml: string;
  acknowledgements: PublicWaiverAcknowledgement[];
};

export type PublicWaiverSignInput = {
  venueId: string;
  signerName: string;
  phone: string | null;
  email: string | null;
  participants: PublicWaiverParticipant[];
  signatureDataUrl: string;
};

export type PublicWaiverParticipant = {
  signerCapacity: SignerCapacity;
  childName: string | null;
  dateOfBirth: string | null;
};

export type PublicWaiverSignResponse = {
  signingBatchId: string;
  records: PublicWaiverRecord[];
};

export type PublicWaiverRecord = {
  id: string;
  templateId: string;
  templateVersion: number;
  signerName: string;
  signerCapacity: SignerCapacity;
  childName: string | null;
  dateOfBirth?: string | null;
  phone: string | null;
  email: string | null;
  status: 'VALID' | 'EXPIRED' | 'REVOKED';
  capturedAt: string;
  expiresAt: string | null;
};

export async function getPublicWaiverTemplate(venueId: string): Promise<PublicWaiverTemplate> {
  return unwrap(
    publicApiClient.GET('/api/v1/public/venues/{venueId}/waivers/active-template', {
      params: { path: { venueId } },
    }),
  );
}

export async function signPublicWaiver(
  input: PublicWaiverSignInput,
): Promise<PublicWaiverSignResponse> {
  const { venueId, ...body } = input;
  return unwrap(
    publicApiClient.POST('/api/v1/public/venues/{venueId}/waivers', {
      params: { path: { venueId } },
      body,
    }),
  );
}
